var validateCheckDigit = function validateCheckDigit(instr) {
  if (instr == null) return instr;
  if (instr.length === 8) {
    var tmp = _upcEToUpcA(instr);
    return tmp && tmp.length === 12 && instr.charAt(7) === tmp.charAt(11);
  } else if (instr.length === 12 || instr.length === 13) {
    return (
      // eslint-disable-next-line eqeqeq
      instr.charAt(instr.length - 1) == _calcCheckDigit(instr.substring(0, instr.length - 1))
    );
  }
  return false;
};
var _calcCheckDigit = function _calcCheckDigit(instr) {
  if (!instr) return instr;
  var mul = instr.length % 2 ? 3 : 1;
  var sum = 0;
  for (var ndx = 0; ndx < instr.length; ndx += 1) {
    sum += mul * instr.charAt(ndx);
    mul = mul === 3 ? 1 : 3;
  }
  return Math.ceil(sum / 10) * 10 - sum;
};
var _upcEToUpcA = function _upcEToUpcA(e) {
  if (!e) return null;
  var instr = null;
  if (e.length === 6) {
    instr = e;
  } else if (e.length === 8) {
    // ...UPC-E must start with '0'
    if (e.substring(0, 1) === "0") {
      instr = e.substring(1, 7);
    }
  }
  var outstr = null;
  if (instr) {
    var lastdig = instr.charAt(5);
    if (lastdig === "0" || lastdig === "1" || lastdig === "2") {
      outstr = "0".concat(instr.substring(0, 2)).concat(lastdig, "0000").concat(instr.substring(2, 5));
      outstr += _calcCheckDigit(outstr);
    } else if (lastdig === "3") {
      outstr = "0".concat(instr.substring(0, 3), "00000").concat(instr.substring(3, 5));
      outstr += _calcCheckDigit(outstr);
    } else if (lastdig === "4") {
      outstr = "0".concat(instr.substring(0, 4), "00000").concat(instr.charAt(4));
      outstr += _calcCheckDigit(outstr);
    } else {
      outstr = "0".concat(instr.substring(0, 5), "0000").concat(lastdig);
      outstr += _calcCheckDigit(outstr);
    }
  }
  return outstr;
};
var isValidUpc = function isValidUpc(upc) {
  return isUpc(upc) || isPluInUpc(upc) || isScaleUpc(upc) || isPrivatePlu(upc) || isInstoreUpc(upc);
};
var isUpc = function isUpc(upc) {
  if (!upc) {
    return false;
  }
  if (upc.match(/^0+$/)) {
    return false;
  }
  if (upc.match(/^0\d{7}$/)) {
    upc = _upcEToUpcA(upc);
  }
  if (!upc) {
    return null;
  } // sometimes while typeing it'll do a check on the first 8 numbers and return a null so is to prevent errors being produced.
  if (!upc.match(/^((\d{8})|(\d{12,13}))$/)) {
    return false;
  }
  var upcTemp = upc.substring(0, upc.length - 1);
  upcTemp += _calcCheckDigit(upcTemp);
  return upc == upcTemp;
};
var isPluInUpc = function isPluInUpc(upc) {
  if (!upc) {
    return null;
  }
  return !!upc.match(/^((20)|(0?2))(\d{5})(\d)(\d{4})\d$/);
};
var isScaleUpc = function isScaleUpc(upc) {
  if (!upc) {
    return null;
  }
  return !!upc.match(/^((20)|(0?2))(\d{5})00000\d$/);
};
var isPrivatePlu = function isPrivatePlu(plu) {
  if (!plu) {
    return null;
  }
  return plu.match(/^[1-9]\d{0,2}$/);
};
var isInstoreUpc = function isInstoreUpc(upc) {
  if (upc) {
    return !!upc.match(/^499\d{9}$/);
  }
  return false;
};
module.exports = {
  isValidUpc: isValidUpc,
  validateCheckDigit: validateCheckDigit
};